'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildDonationUrl = exports.deserializeDonation = exports.fetchDonation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _numbro = require('numbro');

var _numbro2 = _interopRequireDefault(_numbro);

var _jsonDate = require('../../utils/jsonDate');

var _jsonDate2 = _interopRequireDefault(_jsonDate);

var _querystringify = require('querystringify');

var _client = require('../../utils/client');

var _params = require('../../utils/params');

var _justgiving = require('../../utils/justgiving');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var fetchDonation = exports.fetchDonation = function fetchDonation() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();
  return (0, _client.get)('/v1/donation/' + id);
};

var deserializeDonation = exports.deserializeDonation = function deserializeDonation(donation) {
  return {
    amount: parseFloat(donation.donorLocalAmount || donation.amount),
    anonymous: !donation.donorDisplayName || donation.donorDisplayName.toLowerCase().trim() === 'anonymous',
    charity: donation.charityId,
    createdAt: (0, _jsonDate2.default)(donation.donationDate),
    currency: donation.donorLocalCurrencyCode || donation.currencyCode,
    donationRef: donation.donationRef,
    event: donation.eventId,
    message: donation.message,
    name: donation.donorDisplayName,
    page: donation.pageShortName,
    status: donation.status,
    id: donation.id
  };
};

var buildDonationUrl = function buildDonationUrl(_ref) {
  var _ref$amount = _ref.amount,
      amount = _ref$amount === undefined ? (0, _params.required)() : _ref$amount,
      slug = _ref.slug,
      id = _ref.id,
      _ref$currency = _ref.currency,
      currency = _ref$currency === undefined ? 'GBP' : _ref$currency,
      args = _objectWithoutProperties(_ref, ['amount', 'slug', 'id', 'currency']);

  var params = (0, _querystringify.stringify)(_extends({
    amount: (0, _numbro2.default)(amount).format('0.00'),
    currency: currency
  }, args));
  if (slug || id) {
    return id ? (0, _justgiving.baseUrl)('link') + '/v1/fundraisingpage/donate/pageId/' + id + '?' + params : (0, _justgiving.baseUrl)('www') + '/fundraising/' + slug + '/donate?' + params;
  }
};
exports.buildDonationUrl = buildDonationUrl;